module.exports = __webpack_public_path__ + "img/二维码.cb890676.png";